import { useState } from "react";
import { Alert, StyleSheet } from "react-native";
import { ThemedText } from "@/components/ThemedText";
import ThemedScreen from "@/components/ThemedScreen";
import { ThemedButton } from "@/components/ThemedButton";
import { helloWorldFunc } from "@/services/firebase/hello-functions";
import { useFirebase } from "@components/firebase/useFirebase";
import { ThemedView } from "@/components/ThemedView";

export default function TestFirestore() {
  const fb = useFirebase();

  const [output, setOutput] = useState("");

  return (
    <ThemedScreen title="Test Firestore">
      <ThemedButton
        onPress={async () => {
          const out = await helloWorldFunc(fb!, "hello");
          setOutput(out);
        }}
        title="Hellox"
      />

      <ThemedView>
        <ThemedText>Output: {output}</ThemedText>
      </ThemedView>
    </ThemedScreen>
  );
}

const styles = StyleSheet.create({
  headerImage: {
    color: "#808080",
    bottom: -90,
    left: -35,
    position: "absolute",
  },
  titleContainer: {
    flexDirection: "row",
    gap: 8,
  },
});
